import * as React from 'react';
import * as UserRepository from '../../../Repository/UserRepository';
import AdminUsersTable from './AdminUsersTable';
import ModalUserFormGeneric from './ModalUserFormGeneric';
import { Contract, User } from 'tree-wallet-client';
import { stopImpersonation } from '../../../Service/RoleService';
import { default as Page } from '../../../Component/Page/Page';
import { Col, message, Row, Skeleton } from 'antd';
import { UserRoles } from '../../../Repository/UserRepository';
import { GlobalContext } from '../../../Contexts/GlobalContext';
import ErrorBoundary from "../../../Component/ErrorBoundary";
import ErrorPage from "../../ErrorPage/ErrorPage";
import { PlusCircleOutlined } from "@ant-design/icons";
import ModalImpersonation from "./ModalImpersonation";
import { isImpersonating, setImpersonationData } from "../../../Service/RoleService";
import * as AuthService from "../../../Service/AuthService";

const allowedRoles = [
  UserRoles.Admin
];

interface AdminHomePageState {
  userList?: AdminUserDashBoardRow[];
  contract?: Contract,
  loading: boolean;
}

export interface AdminUserDashBoardRow {
  id: number;
  type: string;
  first_name: string;
  last_name: string;
  company: string;
  roles: string;
  cu_roles: string;
  email: string;
  contract_id: number;
  planter_count: number;
  contract_count: number;
}

export async function impersonate(email: string) {
  try {
    // Store the current admin user data before impersonation
    const adminUser = await AuthService.getUser();
    if (adminUser) {
      localStorage.setItem('admin_user', JSON.stringify(adminUser));
    }
    
    // Set impersonation data and redirect
    await setImpersonationData({ user: email });
    
    // Refresh user data as the impersonated user
    await UserRepository.getUser({
      successCallback: async (user: User) => {
        await AuthService.setUser(user);
        window.location.href = '/';
      },
      errorCallback: (error: any) => {
        message.error(error.message);
        console.error(error);
        // If there's an error, clean up and redirect back to admin
        stopImpersonation();
      },
    });
  } catch (error) {
    console.error('Error during impersonation:', error);
    stopImpersonation();
  }
}

export default class AdminUsersPage extends React.Component<any, AdminHomePageState> {
  static contextType = GlobalContext;
  declare context: React.ContextType<typeof GlobalContext>

  constructor(props: any) {
    super(props);
    this.onUpdate = this.onUpdate.bind(this);
    this.state = {
      loading: true,
      userList: undefined,
    };
  }

  async componentDidMount() {
    await this.fetchUsersList();
    this.setState({ loading: false });
  }

  static getDerivedStateFromError(error: any) {
    console.error(error);
    // Mettez à jour l'état, de façon à montrer l'UI de repli au prochain rendu.
    return { hasError: true };
  }

  async fetchUsersList() {
    const contract = this.context.contract;
    await UserRepository.getUsersList({
      params: { contractId: contract && contract.id },
      successCallback: (response: AdminUserDashBoardRow[]) => {
        this.setState({ userList: response })
      }
    })
  }

  onUpdate(editedUser: AdminUserDashBoardRow, values: any) {
    const { userList } = this.state;
    userList && userList.map((value, idx) => {
      if (value.id === editedUser.id) {
        userList[idx] = { ...userList[idx], ...{
          first_name: values.firstName,
          last_name: values.firstName,
          email: values.email,
          role: values.role,
          company: values.company,
          type: values.company ? "INDIVIDUAL" : "COMPANY",
          company_name: values.companyName,
          sector: values.sector,
          website: values.website,
        } };
      }
    });
    this.setState({ userList: JSON.parse(JSON.stringify(userList)) });
  }

  render() {
    const { contract } = this.context;
    const { userList, loading } = this.state;

    if (!contract) {
      return <Page {...this.props} hideMenu={false} title={'treeWallet users'} allowedRoles={allowedRoles}>
        <ErrorPage template={"generic"} subTitle={'No contract defined'} />
      </Page>
    }

    return <Page {...this.props} hideMenu={false} title={'treeWallet users'} allowedRoles={allowedRoles}>
      <Row><Col><h2>Users list</h2></Col></Row>
      {loading
        ? <div>
            <Skeleton active />
        </div>
        : (
          <div>
            <Row>
              <Col>
                <ModalUserFormGeneric
                  openButton={<>Create user <PlusCircleOutlined /></>}
                  modalTitle={`New user`}
                  onSave={async (editedObject: any, values: any) => {
                    const formData = new FormData();
                    Object.entries(values).map(([key, value]) => formData.append(key, String(value)))
                    try {
                      await UserRepository.createUser(formData, {});
                      message.success('User created sucessfully');
                      await this.fetchUsersList();
                    } catch (error) {
                      message.error(error.message);
                    }
                  }}
                />
              </Col>
              {!isImpersonating() &&
                <Col>
                  <ModalImpersonation />
                </Col>
              }
            </Row>
            {userList &&
              <>
                <Row className={'mobile'}>
                  <Col>
                    <ErrorBoundary>
                      <AdminUsersTable
                        contractId={contract.id}
                        list={userList}
                        mode={'mobile'}
                        onUpdate={this.onUpdate}
                      />
                    </ErrorBoundary>
                  </Col>
                </Row>
                <Row className={'desktop'}>
                  <Col>
                    <ErrorBoundary>
                      <AdminUsersTable
                        contractId={contract.id}
                        list={userList}
                        mode={'desktop'}
                        onUpdate={this.onUpdate}
                      />
                    </ErrorBoundary>
                  </Col>
                </Row>
              </>
            }
          </div>
        )
      }
    </Page>
  }
}